import { ChangeDetectionStrategy, Component, forwardRef, OnDestroy, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { cardF } from '@atmi/core/models';
import { BaseCtrlValueAccessorFormArrayComponent, FormManagerService } from '@sim/form';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CprFormComponent),
    },
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CprFormComponent),
    },
  ],
  selector: 'app-cpr-form',
  styleUrls: ['./cpr-form.component.scss'],
  templateUrl: './cpr-form.component.html',
})
export class CprFormComponent extends BaseCtrlValueAccessorFormArrayComponent<cardF.CPR> implements OnDestroy, OnInit {

  constructor(
    private readonly formManager: FormManagerService,
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  addHandler() {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage CPR without a control');
    }

    const control = this.formManager.makeForm(cardF.CPRMeta, {} as cardF.CPR);
    this.form.push(control);
  }

  removeHandler(index: number) {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage CPR without a control');
    }

    this.form.removeAt(index);
  }
}
